
namespace Matrix.Indexation {
    export class FactIndexConstituentRorColumns {
        static columnsKey = 'Indexation.FactIndexConstituentRor';
    }
}